import React, { useState, useLayoutEffect } from 'react';
import { StyleSheet, Platform } from 'react-native';
import NavigationContainer from './navigation/NavigationContainer'
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import reducers from './store/reducers'
import authReducer from './store/authReducer';
import IntroScreens from './screens/IntroScreens';
import AsyncStorage from '@react-native-async-storage/async-storage'

const rootReducer = combineReducers({
  userdata: reducers,
  auth: authReducer
});

const store = createStore(rootReducer, applyMiddleware(ReduxThunk));



export default function App() {
  const [firstTime, setFirstTime] = useState();

  useLayoutEffect(() => {
    const tryStartupScreen = async () => {
        const isFirstTime = await AsyncStorage.getItem('firstTime');
        if (!isFirstTime) {
          setFirstTime(true)
        } else {
          setFirstTime(false)
        }
    }
    tryStartupScreen()
}, [])

  const onDone = () => {
    setFirstTime(false);
    AsyncStorage.setItem('firstTime', JSON.stringify('firsttime'))
  };

  if (firstTime && Platform.OS != 'web') {
    return (
      <IntroScreens done={onDone} />
    )
  }

  return (
    <Provider store={store}>
        <NavigationContainer />
      </Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
